import styled from "styled-components";

/* ── Seção do formulário ─────────────────────────── */

export const FormSection = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0 0 1.25rem;

  &:last-of-type { margin-bottom: 0; }
`;

export const FormSectionTitle = styled.legend`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  margin-bottom: 0.875rem;
  padding: 0;

  span {
    font-size: 0.6875rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: var(--text-label);
    white-space: nowrap;
  }

  i {
    font-size: 0.875rem;
    color: var(--text-label);
  }

  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(0, 0, 0, 0.07);
    body.dark & { background: rgba(255, 255, 255, 0.08); }
  }
`;

/* ── Drop zone de arquivos ───────────────────────── */

export const FileDropZone = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  padding: 1.25rem 1rem;
  border: 1.5px dashed rgba(0, 0, 0, 0.15);
  border-radius: var(--border-radius);
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s ease, background 0.15s ease;
  background: var(--surface-2);

  input[type="file"] {
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
  }

  .drop-icon {
    font-size: 1.75rem;
    color: var(--text-label);
    line-height: 1;
    transition: color 0.15s ease;
  }

  .drop-title {
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--text-secondary);
  }

  .drop-hint {
    font-size: 0.75rem;
    color: var(--text-label);
  }

  &:hover {
    border-color: var(--primary);
    background: rgba(var(--primary-rgb), 0.03);

    .drop-icon { color: var(--primary); }
  }

  &:focus-within {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }

  body.dark & { border-color: rgba(255, 255, 255, 0.15); }
`;

export const FileCountBadge = styled.p`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--primary);
  margin: 0.5rem 0 0;

  i { font-size: 1rem; }
`;

/* ── Toggle group (substitui react-switch-selector) ── */

export const ToggleGroup = styled.div`
  display: flex;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 2rem;
  padding: 3px;
  gap: 2px;

  body.dark & {
    background: var(--surface-3);
    border-color: rgba(255, 255, 255, 0.1);
  }
`;

export const ToggleOption = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: 0.4375rem 1rem;
  border: none;
  border-radius: 2rem;
  font-size: 0.875rem;
  font-weight: ${({ $active }) => ($active ? "700" : "500")};
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
  white-space: nowrap;
  line-height: 1.4;

  background: ${({ $active }) => ($active ? "var(--primary)" : "transparent")};
  color: ${({ $active }) => ($active ? "#fff" : "var(--text-muted)")};
  box-shadow: ${({ $active }) =>
    $active ? "0 2px 8px rgba(var(--primary-rgb),0.28)" : "none"};

  &:hover:not(:disabled) {
    background: ${({ $active }) =>
      $active ? "var(--primary-hover)" : "rgba(0,0,0,0.05)"};
    color: ${({ $active }) => ($active ? "#fff" : "var(--text-secondary)")};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }

  body.dark &:hover:not(:disabled) {
    background: ${({ $active }) =>
      $active ? "var(--primary-hover)" : "rgba(255,255,255,0.06)"};
  }
`;
